import { render } from "./ValueCard.vue?vue&type=template&id=1468a3c4&scoped=true"
import script from "./ValueCard.vue?vue&type=script&lang=js"
export * from "./ValueCard.vue?vue&type=script&lang=js"

import "./ValueCard.vue?vue&type=style&index=0&id=1468a3c4&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1468a3c4"]])

export default __exports__